import React from "react";
import { FiCheck, FiX } from "react-icons/fi";

// Visual mengikuti FormStepIndicator (RegisterMalaria1), namun mendukung
// 5 state: current, completed, available, disabled, error.
const ConfigStepper = ({ steps, statuses, onStepClick }) => (
  <ol className="mps-stepper" aria-label="Langkah konfigurasi">
    {steps.map((step, i) => {
      const status = statuses[i];
      return (
        <li key={step.id} className={`mps-step is-${status}`}>
          <button
            type="button"
            className="mps-step-button"
            disabled={status === "disabled"}
            aria-current={status === "current" ? "step" : undefined}
            onClick={() => onStepClick(step.id)}
          >
            <span className="mps-step-icon">
              {status === "completed" ? (
                <FiCheck size={14} />
              ) : status === "error" ? (
                <FiX size={14} />
              ) : (
                step.id
              )}
            </span>
            <span className="mps-step-label">{step.label}</span>
          </button>
          {i < steps.length - 1 && <span className="mps-step-bar" />}
        </li>
      );
    })}
  </ol>
);

export default ConfigStepper;
